import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_PatientFinancialResponsibility = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_PatientFinancialResponsibility' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    Thank you for choosing <strong>Life Solutions South </strong>for your medical needs. We are committed to providing you with the highest
                    quality healthcare. We ask that you read and sign this form to acknowledge your understanding of our Client Financial
                    policies.
                </p>
                <h3>Client Financial Responsibilities</h3>
                <p className='w-750'>
                    The Client (or Client's guardian, if a minor) is ultimately responsible for the payment for treatment and care.
                </p>
                <p className='w-750'>
                    We will bill your insurance for you. However, the Client is required to provide the most correct and updated
                    information regarding insurance. If we are unable to process payment through your insurance for any reason we
                    will bill you for the services provided at the following rates:
                </p>

                <p className='w-750 keep-together'>
                    <ol>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Individual Psychotherapy</td>
                                    <td className='w-250'>1-hour Session</td>
                                    <td className='w-100'>$55.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Group Psychotherapy</td>
                                    <td className='w-250'>1-hour Session</td>
                                    <td className='w-100'>$75.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Family Psychotherapy</td>
                                    <td className='w-250'>1-hour Session</td>
                                    <td className='w-100'>$75.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Diagnostic Evaluation</td>
                                    <td className='w-250'>Flat fee</td>
                                    <td className='w-100'>$50.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Community Psychiatric Supportive Treatment</td>
                                    <td className='w-250'>1-hour Session</td>
                                    <td className='w-100'>$35.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Therapeutic Behavioral Services</td>
                                    <td className='w-250'>1-hour Session</td>
                                    <td className='w-100'>$35.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Psychosocial Rehabilitation</td>
                                    <td className='w-250'>1-hour Session</td>
                                    <td className='w-100'>$35.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Assertive Community Treatment</td>
                                    <td className='w-250'>1-hour Session</td>
                                    <td className='w-100'>$75.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Intensive Home-Based Therapy</td>
                                    <td className='w-250'>1-hour Session</td>
                                    <td className='w-100'>$75.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Substance Use Disorder Assessment & ASAM</td>
                                    <td className='w-250'>Flat fee</td>
                                    <td className='w-100'>$50.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Substance Use Disorder Services</td>
                                    <td className='w-250'>1-hour Session</td>
                                    <td className='w-100'>$35.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Intensive Outpatient Treatment</td>
                                    <td className='w-250'>Hourly Rate</td>
                                    <td className='w-100'>$75.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Medication Management</td>
                                    <td className='w-250'>Flat fee</td>
                                    <td className='w-100'>$50.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Tbs Day Treatment</td>
                                    <td className='w-250'>Hourly Rate per Diem</td>
                                    <td className='w-100'>$75.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Mobile Response and Stabilization Service(MRSS)</td>
                                    <td className='w-250'>Flat fee </td>
                                    <td className='w-100'>$100.00</td>
                                </tr>
                            </table>
                        </li>
                        <li>
                            <table>
                                <tr>
                                    <td className='w-350'>Peer Support</td>
                                    <td className='w-250'>Flat fee</td>
                                    <td className='w-100'>$35.00</td>
                                </tr>
                            </table>
                        </li>
                    </ol>

                </p>
                <p>
                    Clients are responsible for payment of copays, coinsurance, deductibles and all other procedures or treatment not
                    covered by their insurance plan
                </p>
                <p>
                    Copays are due at the time of service
                </p>
                <p>
                    Coinsurance deductibles and non-covered items are due 30 days from receipt of billing
                </p>
                <p>Clients may incur, and are responsible for payment of additional charges, if applicable. These charges may include:
                    Charge for returned checks - $30.00</p>
                <p>
                    By my signature below, I hereby authorize assignment of financial benefits directly to <strong>Life Solutions South</strong> and any
                    associated healthcare entities for service rendered as allowed under standard third-party contracts. I understand that I am
                    financially responsible for charges not covered by this assignment.
                </p>
                <h3>Client Acknowledgement and Authorization</h3>
                <p>
                    We respect Client confidentiality and only release personal health information about you in accordance with the State and
                    Federal law. The attached notice describes our policies related to the use of the records of your care and how you may get
                    access to this information. Please review this policy carefully. Bu my signature below, I acknowledge that I have received
                    and read the privacy notice provided by <strong>Life Solutions South</strong> to release medical and other information acquired in the
                    course of my examination and/or treatment to the necessary insurance companies, third party payors, and or other
                    physicians or healthcare entities to participate in my care.
                </p>
                <table>
                    <tr>
                        <td className='w-375 signature'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-375 small">Client Name (Printed)</td>
                    </tr>
                    <tr>
                        <td className='w-375 signature' >&nbsp;</td>
                        <td className='w-375 signature' >&nbsp;</td>

                    </tr>
                    <tr>
                        <td className="w-375 small">Client/Parent/Legal Guardian Signature </td>
                        <td className="w-375 small">Date</td>
                    </tr>
                </table>
            </div>
        </form>

    )
}


